import script from "./BottomBar.vue?vue&type=script&setup=true&lang=js"
export * from "./BottomBar.vue?vue&type=script&setup=true&lang=js"

import "./BottomBar.vue?vue&type=style&index=0&id=28b277ec&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28b277ec"]])

export default __exports__